var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"info","loading":_vm.loading,"disabled":!_vm.ok},on:{"click":_vm.submit}},[_vm._v("Alert Me")])
}
var staticRenderFns = []

export { render, staticRenderFns }